export default __webpack_public_path__ + "static/media/facebook.bee07f76.png";